import {observer} from 'mobx-react';
import EmployeeSuggestion from 'shared/components/searchable_dropdown/suggestions/EmployeeSuggestion';
import CandidateSuggestion from 'shared/components/searchable_dropdown/suggestions/CandidateSuggestion';
import GenericSuggestion from 'shared/components/searchable_dropdown/suggestions/GenericSuggestion';
import NavigationSuggestion from 'shared/components/searchable_dropdown/suggestions/NavigationSuggestion';

const Suggestion = observer(({viewModel, query, translatable=false}) => {
  switch (viewModel.data.suggestionType) {
    case 'employee':
      return <EmployeeSuggestion viewModel={viewModel} query={query}/>;
    case 'candidate':
      return <CandidateSuggestion viewModel={viewModel} query={query}/>;
    case 'navigation':
      return <NavigationSuggestion viewModel={viewModel} query={query}/>;
    default:
      return <GenericSuggestion viewModel={viewModel} translatable={translatable} query={query}/>;
  }
});

export default Suggestion;
